// ErrorPage.jsx
import React from 'react';
import './ErrorPage.css'; // optional if you use Tailwind

export const ErrorPage = () => {
  return (
    <div className="error-page-container">
      <div className="error-card">
        <h1>🚫 Something Went Wrong</h1>
        <p>Please contact the administrator.</p>
        <p>Email: <a href="mailto:support@yourdomain.com">support@yourdomain.com</a></p>
      </div>
    </div>
  );
};

export default ErrorPage;
